module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    key: _vm.key,
    ref: _vm.componentId,
    on: {
      "input": _vm.closeInput
    }
  }, [_c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('h2', [_vm._v("Plan Details")]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Plan Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.name),
      expression: "plan.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plan, "name", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Title")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.title),
      expression: "plan.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plan, "title", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Duration (days)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.duration),
      expression: "plan.duration"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plan, "duration", $event.target.value)
      }
    }
  }), _c('small', [_vm._v("The contractual commitment of the plan (days).")])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Subscription End"), _c('DatePicker', {
    attrs: {
      "initialDate": _vm.plan.subscription_end,
      "pickTime": true,
      "format": "yyyy-mm-dd",
      "clearCb": function () {
        _vm.plan.subscription_end = null
      }
    },
    model: {
      value: (_vm.plan.subscription_end),
      callback: function($$v) {
        _vm.$set(_vm.plan, "subscription_end", $$v)
      },
      expression: "plan.subscription_end"
    }
  })], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Max Drivers")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.max_drivers),
      expression: "plan.max_drivers"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.max_drivers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plan, "max_drivers", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.status),
      expression: "plan.status"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.plan, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("AVAILABLE")]), _c('option', [_vm._v("UNAVAILABLE")]), _c('option', [_vm._v("DISABLED")])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Color"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.color),
      expression: "plan.color"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plan, "color", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Notice"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.notice),
      expression: "plan.notice"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.notice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plan, "notice", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row column"
  }, [_c('label', [_vm._v("Toc")]), _c('SelectizeToc', {
    attrs: {
      "selectedValue": _vm.plan.toc_id
    },
    on: {
      "optionSelected": _vm.setTocId,
      "optionRemoved": function($event) {
        _vm.plan.toc_id = null
      }
    }
  })], 1)]), _c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('h2', [_vm._v("Plan Costs")]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Subscriptions can be renewed?  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.renewable),
      expression: "plan.renewable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plan.renewable) ? _vm._i(_vm.plan.renewable, null) > -1 : (_vm.plan.renewable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plan.renewable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.plan, "renewable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.plan, "renewable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.plan, "renewable", $$c)
        }
      }
    }
  })]), _c('label', [_vm._v("Featured  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.featured),
      expression: "plan.featured"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plan.featured) ? _vm._i(_vm.plan.featured, null) > -1 : (_vm.plan.featured)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plan.featured,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.plan, "featured", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.plan, "featured", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.plan, "featured", $$c)
        }
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('VatAmountToggler', {
    attrs: {
      "label": "Cost",
      "tax": _vm.configuration.commercial.commercial_vat_rate.value
    },
    model: {
      value: (_vm.plan.cost),
      callback: function($$v) {
        _vm.$set(_vm.plan, "cost", $$v)
      },
      expression: "plan.cost"
    }
  })], 1), (_vm.plan.renewable) ? _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Billing Cycle (days)"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.billing_cycle),
      expression: "plan.billing_cycle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.billing_cycle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plan, "billing_cycle", $event.target.value)
      }
    }
  })]), _c('small', [_vm._v("The frequency (days) with which the plan cost is charged")])]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-6"
  }, [_c('label', [_vm._v("Active From"), _c('DatePicker', {
    attrs: {
      "initialDate": _vm.plan.valid_from,
      "pickTime": true,
      "format": "yyyy-mm-dd hh:ii:ss",
      "clearCb": function () {
        _vm.plan.valid_from = null
      }
    },
    model: {
      value: (_vm.plan.valid_from),
      callback: function($$v) {
        _vm.$set(_vm.plan, "valid_from", $$v)
      },
      expression: "plan.valid_from"
    }
  })], 1)]), _c('div', {
    staticClass: "columns large-6"
  }, [_c('label', [_vm._v("Active To"), _c('DatePicker', {
    attrs: {
      "initialDate": _vm.plan.valid_to,
      "pickTime": true,
      "format": "yyyy-mm-dd hh:ii:ss",
      "clearCb": function () {
        _vm.plan.valid_to = null
      }
    },
    model: {
      value: (_vm.plan.valid_to),
      callback: function($$v) {
        _vm.$set(_vm.plan, "valid_to", $$v)
      },
      expression: "plan.valid_to"
    }
  })], 1)])]), _c('div', {
    staticClass: "row columns"
  }), _c('div', {
    staticClass: "row columns"
  }, [_c('label', [_vm._v("Picture")]), _c('KeplerFileUpload', {
    attrs: {
      "selected-prefix": "plans",
      "selected-visibility": "public",
      "previewUrl": _vm.plan.picture
    },
    on: {
      "sel": _vm.handleFileSelector
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
    attrs: {
      "value": _vm.plan.description
    },
    model: {
      value: (_vm.plan.description),
      callback: function($$v) {
        _vm.$set(_vm.plan, "description", $$v)
      },
      expression: "plan.description"
    }
  })], 1)]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ff60323!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/PlanReveal.vue
// module id = 2196
// module chunks = 1